import { useEffect, useState } from "react";
import { WhatsappLogo, Camera } from "@phosphor-icons/react";
import { buildWhatsAppLink } from "../lib/brand";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <a
      data-testid="whatsapp-float-btn"
      href={buildWhatsAppLink(
        "Olá! Quero enviar a foto do meu material (alumínio/cobre) para avaliação.",
      )}
      target="_blank"
      rel="noopener noreferrer"
      className="rc-pop-in fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-50 group"
      aria-label="Enviar foto do material pelo WhatsApp"
    >
      <div className="flex items-center gap-3 rc-btn-whatsapp pl-3 pr-4 sm:pl-4 sm:pr-5 py-3 sm:py-3.5 rounded-full shadow-2xl">
        <span className="relative inline-flex items-center justify-center">
          <span className="absolute inset-0 rounded-full rc-ring" aria-hidden />
          <WhatsappLogo size={26} weight="fill" className="relative" />
        </span>
        <span className="hidden sm:flex flex-col leading-tight pr-1">
          <span className="text-[10px] uppercase tracking-widest opacity-80 font-mono-ui">
            WhatsApp
          </span>
          <span className="text-sm font-bold font-display flex items-center gap-1.5">
            <Camera size={16} weight="bold" /> Enviar foto do material
          </span>
        </span>
        <span className="sm:hidden text-sm font-bold font-display whitespace-nowrap">
          Enviar foto
        </span>
      </div>
    </a>
  );
}
